export default __webpack_public_path__ + "static/media/dap-weldwood.2e59a97b.jpeg";